// 顶点着色器程序
export const VSHADER_SOURCE = `
attribute lowp vec4 a_Position;
attribute vec2 a_texturePosition;
varying vec2 v_texCoord;
void main() {
	gl_Position = a_Position;
	v_texCoord = a_texturePosition;
}
`;

// 片源着色器
export const FSHADER_SOURCE = `
precision lowp float;
uniform sampler2D samplerY;
uniform sampler2D samplerU;
uniform sampler2D samplerV;
varying vec2 v_texCoord;
void main() {
	float r,g,b,y,u,v,fYmul;
	y = texture2D(samplerY, v_texCoord).r;
	u = texture2D(samplerU, v_texCoord).r;
	v = texture2D(samplerV, v_texCoord).r;

	fYmul = y * 1.1643828125;
	r = fYmul + 1.59602734375 * v - 0.870787598;
	g = fYmul - 0.39176171875 * u - 0.81296875 * v + 0.52959375;
	b = fYmul + 2.01723046875 * u - 1.081389160375;
	gl_FragColor = vec4(r, g, b, 1.0);
}
`;

export const vertices0 = new Float32Array([
  1, 1, 0.0, -1, 1, 0.0, 1, -1, 0.0, -1, -1, 0.0,
]);

export const vertices90 = new Float32Array([
  1, -1, 0.0, 1, 1, 0.0, -1, -1, 0.0, -1, 1, 0.0,
]);

export const vertices180 = new Float32Array([
  -1, -1, 0.0, 1, -1, 0.0, -1, 1, 0.0, 1, 1, 0.0,
]);

export const vertices270 = new Float32Array([
  -1, 1, 0.0, -1, -1, 0.0, 1, 1, 0.0, 1, -1, 0.0,
]);
